<template>
  <div class="notice_detail">
    <div class="head_container">
      <div class="head_title">{{noticeData.title}}</div>
      <div class="head_date">
        <div class="date">{{noticeData.updateTime}}</div>
        <div class="right" @click="allNotice">全部公告</div>
      </div>
    </div>
    <div class="notice_body" v-html="noticeData.digest"></div>
  </div>
</template>

<script>
export default {
  name: "notice-detail",
  data() {
    return {
      // 公告详情数据
      noticeData: {}
    };
  },
  mounted() {
    this.getNoticeDetail();
  },
  methods: {
    /**
     * 获取公告详情数据
     */
    getNoticeDetail() {
      this.$request.get(`/appserver/v1/notice/detail?articleId=${this.$route.query.id}`).then((res) => {
        if (res.data.ret == 0) {
          this.noticeData = res.data.data;
        } else {
          console.log('接口出错');
        }
      }).catch((e) => {
        console.log('接口出错');
      });
    },
    /**
     * 跳转全部公告列表
     */
    allNotice() {
      this.$router.push({
          name:'noticeList',
      })
    }

  },
};
</script>
<style lang="scss">
.notice_detail {
  padding: 0 20px;
  box-sizing: border-box;
  .head_container {
    margin-top: 20px;
    .head_title {
      color: #262626;
      font-size: 24px;
      font-weight: bold;
    }
    .head_date {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      margin-bottom: 30px;
      .date {
        color: #bfbfbf;
        font-size: 14px;
      }
      .right {
        color: #2ed07e;
        font-size: 14px;
      }
    }
  }
  .notice_body {
    color: #787878;
    font-size: 14px;
    letter-spacing: 0.5px;
    word-break: break-all;
    img {
      width: 100%;
      height: auto;
      margin: 20px 0px;
    }
    /deep/p{
      margin-bottom: 10px;
    }
  }
}
</style>
